/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MyTournamentNextMatchResponse } from './MyTournamentNextMatchResponse';
import {
    MyTournamentNextMatchResponseFromJSON,
    MyTournamentNextMatchResponseFromJSONTyped,
    MyTournamentNextMatchResponseToJSON,
    MyTournamentNextMatchResponseToJSONTyped,
} from './MyTournamentNextMatchResponse';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
    TournamentToJSONTyped,
} from './Tournament';

/**
 * A user's tournament entry with team and captain info
 * @export
 * @interface MyTournamentEntryResponse
 */
export interface MyTournamentEntryResponse {
    /**
     * 
     * @type {Tournament}
     * @memberof MyTournamentEntryResponse
     */
    tournament: Tournament;
    /**
     * 
     * @type {TournamentTeamResponse}
     * @memberof MyTournamentEntryResponse
     */
    team: TournamentTeamResponse;
    /**
     * Whether the user is the team captain
     * @type {boolean}
     * @memberof MyTournamentEntryResponse
     */
    isCaptain: boolean;
    /**
     * 
     * @type {MyTournamentNextMatchResponse}
     * @memberof MyTournamentEntryResponse
     */
    nextMatch?: MyTournamentNextMatchResponse;
    /**
     * Final placement (1 = champion, 2 = runner-up); set once the tournament completes
     * @type {number}
     * @memberof MyTournamentEntryResponse
     */
    finalPlacement?: number;
}

/**
 * Check if a given object implements the MyTournamentEntryResponse interface.
 */
export function instanceOfMyTournamentEntryResponse(value: object): value is MyTournamentEntryResponse {
    if (!('tournament' in value) || value['tournament'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('isCaptain' in value) || value['isCaptain'] === undefined) return false;
    return true;
}

export function MyTournamentEntryResponseFromJSON(json: any): MyTournamentEntryResponse {
    return MyTournamentEntryResponseFromJSONTyped(json, false);
}

export function MyTournamentEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyTournamentEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': TournamentFromJSON(json['tournament']),
        'team': TournamentTeamResponseFromJSON(json['team']),
        'isCaptain': json['isCaptain'],
        'nextMatch': json['nextMatch'] == null ? undefined : MyTournamentNextMatchResponseFromJSON(json['nextMatch']),
        'finalPlacement': json['finalPlacement'] == null ? undefined : json['finalPlacement'],
    };
}

export function MyTournamentEntryResponseToJSON(json: any): MyTournamentEntryResponse {
    return MyTournamentEntryResponseToJSONTyped(json, false);
}

export function MyTournamentEntryResponseToJSONTyped(value?: MyTournamentEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': TournamentToJSON(value['tournament']),
        'team': TournamentTeamResponseToJSON(value['team']),
        'isCaptain': value['isCaptain'],
        'nextMatch': MyTournamentNextMatchResponseToJSON(value['nextMatch']),
        'finalPlacement': value['finalPlacement'],
    };
}

